@if (activeNavigationItem.action == 'gdvPartner') {

    <div class="grid">
        <div class="col-12">
            <mvs-widget *ngIf="basicWidgetData" [widgetData]="basicWidgetData"></mvs-widget>
        </div>

        <div class="col-12">
            @if (!dto?.schemaDtoId) {
                <p-button label="Schema einrichten"
                          icon="fa-regular fa-wand-magic-sparkles"
                          [disabled]="busy"
                          (click)="openSchemaSetupDialog()">
                </p-button>
            } @else {
                <p-button label="Schema neu generieren / Erweiterung hochladen"
                          icon="fa-regular fa-rotate"
                          severity="secondary"
                          [outlined]="true"
                          [disabled]="busy"
                          (click)="openSchemaSetupDialog()">
                </p-button>
            }
        </div>
    </div>

    @if (dto) {
        <hg-partner-schema-setup-dialog
                [(visible)]="schemaSetupDialogVisible"
                [partner]="dto"
                (onSchemaUpdated)="handleSchemaUpdated($event)">
        </hg-partner-schema-setup-dialog>
    }
}
@if (activeNavigationItem.action == 'test') {
    <hg-gdv-test-component
            *ngIf="objectIdentifier.objectId"
            [hgPartnerId]="objectIdentifier.objectId"
    ></hg-gdv-test-component>
}
@if (activeNavigationItem.action == 'imports') {
    <div class="flex flex-column gap-3">
        <div class="flex justify-content-end">
            <p-fileupload
                    mode="basic"
                    [customUpload]="true"
                    (uploadHandler)="uploadGdvFile($event)"
                    [auto]="true"
                    chooseLabel="GDV-Datei hochladen"
                    chooseIcon="fa-regular fa-upload"
                    accept="*/*">
            </p-fileupload>
        </div>
        <!--
            Row-click deep-link into the Multi-Stage Import Object-Review page.
            A row-click triggers handleHgImportSelect(), which conditionally
            navigates to "Zur Objekt-Prüfung" only when the associated
            EiImport exists AND its phase === OBJECT_REVIEW.
        -->
        @if (hgImportsWidgetData) {
            <mvs-widget [widgetData]="hgImportsWidgetData"
                        (onObjectSelect)="handleHgImportSelect($event)"></mvs-widget>
        }
    </div>
}
@if (activeNavigationItem.action == 'partnerPartners') {
    @if (partnerPartnersWidget) {
        <mvs-widget [widgetData]="partnerPartnersWidget"
                    (onObjectSelect)="handleChildObjectSelect($event)">
        </mvs-widget>
    }
}
@if (activeNavigationItem.action == 'exportSatzarten') {
    @if (exportSatzartenWidget) {
        <mvs-widget [widgetData]="exportSatzartenWidget"
                    (onObjectSelect)="handleChildObjectSelect($event)">
        </mvs-widget>
    }
}
@if (activeNavigationItem.action == 'flowOverrides') {
    @if (flowOverridesWidget) {
        <mvs-widget [widgetData]="flowOverridesWidget"
                    (onObjectSelect)="handleChildObjectSelect($event)">
        </mvs-widget>
    }
}
